module.exports = __webpack_public_path__ + "static/media/Mar2-S19.85462aad.png";